import { isEmpty } from 'lodash';
import { object, string } from 'yup';
const PropertyInformation = object({
  financedUnitCount: string().required('Please select number of units'),
  propertyStructureBuiltYear: string().notRequired().test('Please provide a valid year', 'Please provide a valid year', value => isEmpty(value) ? true : Number(value) >= 1800 && Number(value) <= new Date().getFullYear()),
  neighborhoodHousingType: string().required('Please select property type'),
  propertyCurrentUsageType: string().required('Please select home use'),
  propertyValuationAmount: string().required('Please provide an estimated value'),
  propertyMixedUsageIndicator: string().required('Please select an option'),
  homeownersAssociationDuesPaymentAmount: string().required('Please provide HOA Fee. If you don’t have HOA Fee, then enter $0')
});
export default PropertyInformation;
//# sourceMappingURL=index.js.map